import React from 'react'
import MainLayout from "./layouts/MainLayout";  
import MeetingLayout from "./layouts/MeetingLayout";   
 
 
const MyProfile = React.lazy(() => import('./Pages/Dashboard/MyProfile'))
const MyAssignment = React.lazy(() => import('./Pages/Dashboard/MyAssignment'))
const AssignmentDetails = React.lazy(() => import('./Pages/AssignmentDetails'))
const VideoCalls = React.lazy(() => import('./Pages/Dashboard/VideoCalls')) 
const AllMessages = React.lazy(() => import('./Pages/AllMessages')) 

 

const OHIFViewer = React.lazy(() => import('./Pages/Dashboard/OHIFViewer')) 
const CreateMeeting = React.lazy(() => import('./Pages/Dashboard/CreateMeeting')) 


export default [ 
     {
        path: "/my-assignment",
        exact: true,
        layout: MainLayout,
        component: MyAssignment
    },{
        path: "/dashboard",
        exact: true,
        layout: MainLayout,
        component: MyProfile
    }, {
        path: "/ohif-viewer",
        exact: true,
        layout: MainLayout,
        component: OHIFViewer
    }, {
        path: "/image-viewer/:id",
        exact: true,
        layout: MainLayout,
        component: OHIFViewer
    },{
        path: "/create-meeting",
        exact: true,
        layout: MeetingLayout,
        component: CreateMeeting
    },{
        path: "/video-calls",
        exact: true,
        layout: MainLayout,
        component: VideoCalls
    },{
        path: "/details",
        exact: true,
        layout: MainLayout,
        component: AssignmentDetails
    },{
        path: "/all-messages",
        exact: true,
        layout: MainLayout,
        component: AllMessages
    }
];